import React from 'react';

import {
    ajax, loadPickUpAddress, loadCarrierSets, autoCompleteForeignCities, validateCarrierRules,
    loadAutocompleteCountries,
    autoCompleteForeignCitiesForCountry,
    loadPackageConfig, loadOrderServices,
    loadReturnedOrders,
    loadRecipientAddresses,
    loadUPSProvinceCodes,
    UPSCourier,
    USCountryCode,
    canadaCountryCode
    
} from '../components/globals';
import { Languages } from '../components/languages';

import {
    InputSection,  URadioComplex, OrderCostMessage} from '../components/utilities';
import {
    numberValidation, nameValidation, emailValidation, emptyValidation, isTrueValidation, zipValidation, phoneValidation,
    validate
} from '../components/validate';

import { SingleOrderPackage } from '../components/ordercommon';

import { FieldProps } from '../components/fieldProps';

import { UIOrderPackageConfig, PageTitle, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect } from '../components/guiElements';
import { CreditBoxWidget } from '../components/creditBoxWidget';

import { v4 as uuidv4 } from 'uuid';

export class SingleOrderCreation extends React.Component {
    constructor(props) {
        super(props);
        this.location = props.location;
        this.createOrder = this.createOrder.bind(this);
        this.confirmOrder = this.confirmOrder.bind(this);
        this.dataChange = this.dataChange.bind(this);
        this.onPackageOptionChange = this.onPackageOptionChange.bind(this)
        this.packageChange = this.packageChange.bind(this);
        this.orderChange = this.orderChange.bind(this);
        this.serviceChange = this.serviceChange.bind(this);
        this.addressChange = this.addressChange.bind(this);
        this.autocompletePlaceSelected = this.autocompletePlaceSelected.bind(this);
        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);
        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this);

        this.warehouseSenderChange = this.warehouseSenderChange.bind(this);
        this.warehouseSenderClick = this.warehouseSenderClick.bind(this);
        
        // this.warehouseRecipientChange = this.warehouseRecipientChange.bind(this);
        // this.warehouseRecipientClick = this.warehouseRecipientClick.bind(this);

        this.closeModal = this.closeModal.bind(this);
        this.closeOrderOkModal = this.closeOrderOkModal.bind(this);
        this.addPackage = this.addPackage.bind(this);
        this.removePackage = this.removePackage.bind(this);
        this.orderCostCalculation = this.orderCostCalculation.bind(this);
        this.carrierCostModalAction = this.carrierCostModalAction.bind(this);
        
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.SingleOrderCreation[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.inputBoxes = [
            {
                id: 'inputs',
                title: '',
                class: '', 
                columns: [
                    {
                        id: 'triangulation',
                        title: { rowClass: '', colClass: '', value: this.le.triangulation.title },
                        rowsize: 100,
                        itemunit: 30,
                        items: [
                            { id: 'name', mandatory: true, size: 100, text: this.le.triangulation.inputs[0], type: 'text', maxLength: FieldProps.getFieldProp('name', 'maxLength'), 
                                validate: emptyValidation, value: ''
                            },
                            { id: 'surname', mandatory: true, size: 100, text: this.le.triangulation.inputs[1],  type: 'text',  maxLength: FieldProps.getFieldProp('surname', 'maxLength'),
                                validate: emptyValidation, value: '' },
                            {
                                id: 'at', size: 100, text: this.le.triangulation.inputs[2], type: 'text', maxLength: FieldProps.getFieldProp('at', 'maxLength'), 
                                value: ''
                            },
                            {
                                id: 'country', mandatory: true, size: 100, text: this.le.triangulation.inputs[5], type: 'selectField', maxLength: FieldProps.getFieldProp('country', 'maxLength'),
                                source: "triangulation", 
                                options: [],  value: ''
                            },
                            {
                                id: 'city', mandatory: true, size: 100, text: this.le.triangulation.inputs[6], type: 'autocomplete', maxLength: FieldProps.getFieldProp('city', 'maxLength'),
                                validate: emptyValidation, disabled: false, options: [],  value: ''
                            },
                            
                            {
                                id: 'province', mandatory: true, size: 70, width: '70%', text: this.le.triangulation.inputs[7], type: 'text', maxLength: FieldProps.getFieldProp('province', 'maxLength'),
                                validate: nameValidation, disabled: true,   value: ''
                            },
                            {
                                id: 'zip', mandatory: true, size: 30, width: '28%', text: this.le.triangulation.inputs[8], type: 'text',
                                validate: zipValidation, disabled: true,  value: ''

                            },
                            {
                                id: 'address', mandatory: true,size: 70, width: '70%', text: this.le.triangulation.inputs[3], maxLength: FieldProps.getFieldProp('address', 'maxLength'),
                                validate: emptyValidation, type: 'text',  value: ''
                            },
                            {
                                id: 'houseNo', size: 30, width: '28%', maxLength: FieldProps.getFieldProp('houseNo', 'maxLength'),
                                text: this.le.triangulation.inputs[4], type: 'text', value: ''
                            },
                           
                            {
                                id: 'number', mandatory: false, size: 100, text: this.le.triangulation.inputs[9], type: 'text', maxLength: FieldProps.getFieldProp('phone', 'maxLength'),
                                value: ''
                            },
                        ]
                    },
                    {
                        id: 'sender',
                        title: { rowClass: '', colClass: '', value: this.le.sender.title },
                        rowsize: 100,
                        itemunit: 30,
                        items: [
                            { id: 'selectedPickup', size: 100, text: this.le.sender.warehouse, type: 'select', options: [{text:'---------', value:''}], disabled: false, },
                            { id: 'name', size: 100, text: this.le.sender.inputs[0], type: 'text', maxLength: FieldProps.getFieldProp('name', 'maxLength'), validate: emptyValidation,mandatory:true},
                            { id: 'surname', size: 100, text: this.le.sender.inputs[1], type: 'text', maxLength: FieldProps.getFieldProp('surname', 'maxLength')},
                            { id: 'at', size: 100, text: this.le.sender.inputs[2], type: 'text', maxLength: FieldProps.getFieldProp('at', 'maxLength') },
                            { id: 'city', mandatory: true, size: 100, text: this.le.sender.inputs[5], type: 'autocomplete',options:[], validate: emptyValidation, maxLength: FieldProps.getFieldProp('city', 'maxLength') },
                            { id: 'province', mandatory: true, size: 70, width: '70%', text: this.le.sender.inputs[6], type: 'text', validate: nameValidation, maxLength: FieldProps.getFieldProp('province', 'maxLength') },
                            { id: 'zip', mandatory: true, size: 30, width: '28%', text: this.le.sender.inputs[7], type: 'text', validate: zipValidation },
                            { id: 'address', mandatory: true, size: 70, width: '70%', text: this.le.sender.inputs[3], type: 'text', validate: emptyValidation, maxLength: FieldProps.getFieldProp('address', 'maxLength') },
                            { id: 'houseNo', size: 30, width: '28%', text: this.le.sender.inputs[4], type: 'text', maxLength: FieldProps.getFieldProp('houseNo', 'maxLength')  },
                            { id: 'number', mandatory: true, validate: phoneValidation, size: 100, text: this.le.sender.inputs[8], type: 'text', maxLength: FieldProps.getFieldProp('phone', 'maxLength') },
                            { id: 'email', mandatory: true, validate:emailValidation,size: 100, text: this.le.sender.inputs[9], type: 'text', maxLength: FieldProps.getFieldProp('email', 'maxLength') },
                            { id: 'note', size: 100, text: this.le.sender.inputs[10], type: 'text', maxLength: FieldProps.getFieldProp('note', 'maxLength')  }
                        ]
                    },
                    {
                        id: 'recipient',
                        title: { rowClass: '', colClass: '', value: this.le.recipient.title },
                        rowsize: 100,
                        itemunit: 30,
                        items: [
                            { id: 'selectedPickup', size: 100, text: this.le.recipient.warehouse, type: 'select', options: [{text:'---------',value:''}] },
                            { id: 'name', mandatory: true, size: 100, text: this.le.recipient.inputs[0], type: 'text', maxLength: FieldProps.getFieldProp('name', 'maxLength'),  validate: emptyValidation},
                            { id: 'surname', size: 100, text: this.le.recipient.inputs[1], maxLength: FieldProps.getFieldProp('surname', 'maxLength'),type: 'text' },
                            {
                                id: 'at', size: 100, text: this.le.recipient.inputs[2], maxLength: FieldProps.getFieldProp('at', 'maxLength'),
                                type: 'text'
                            },
                            {
                                id: 'country', mandatory: true, size: 100, text: this.le.recipient.inputs[5], maxLength: FieldProps.getFieldProp('country', 'maxLength'),
                                source: "recipient",
                                type: 'selectField', options: []
                            },
                            {
                                id: 'city', mandatory: true, size: 100, text: this.le.recipient.inputs[6], maxLength: FieldProps.getFieldProp('city', 'maxLength'),
                                disabled: false,
                                type: 'autocomplete', options: [], validate: emptyValidation
                            },
                            
                            {
                                id: 'province', mandatory: true, size: 100, text: this.le.recipient.inputs[7],
                                maxLength: FieldProps.getFieldProp('province', 'maxLength'),
                                disabled: true,
                                type: 'text',
                                options: [],
                                validate: emptyValidation,
                                value: ''
                            },
                            {
                                id: 'zip', mandatory: true, size: 30, width: '28%', text: this.le.recipient.inputs[8],
                                disabled: true,
                                type: 'text', validate: zipValidation

                            },
                            {
                                id: 'address', mandatory: true,size: 70, width: '70%', text: this.le.recipient.inputs[3], maxLength: FieldProps.getFieldProp('address', 'maxLength'),
                                type: 'text', validate: emptyValidation
                            },
                            {
                                id: 'houseNo', size: 30, width: '28%', maxLength: FieldProps.getFieldProp('houseNo', 'maxLength'),
                                text: this.le.recipient.inputs[4], type: 'text'
                            },
                           
                            {
                                id: 'number', mandatory: true, validate: phoneValidation,size: 100, text: this.le.recipient.inputs[9], maxLength: FieldProps.getFieldProp('phone', 'maxLength'),
                                type: 'text'
                            },
                            {
                                id: 'email', mandatory: true, validate: emailValidation,size: 100, text: this.le.recipient.inputs[10], maxLength: FieldProps.getFieldProp('email', 'maxLength'),
                                type: 'text'
                            },
                            {
                                id: 'note', size: 100, text: this.le.recipient.inputs[11], maxLength: FieldProps.getFieldProp('note', 'maxLength'),
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ];
        
        this.state = {
            senderWarehouses: [],
            recipientWarehouses: [],
            carriers: [],
            modalType: 0,
            modalSel: '',
            modalMsg: '',
            data: this.buildPostData(),
            packageItems: [],
            packageOptions: [],
            countries: [],
            newCanadaProvinceCodes: [],
            newUSProvinceCodes: [],
            countryCode: {
                0: 'IT',
                2: 'IT'
            },
            suggestedCountry: {
                0: [],
                2: []
            },
            suggestedCity: {
                0: [],
                1: [],
                2: []
            },
            showTriangolationSection: false,
            isSelectedRecipientCountryEu: true,
            isVisibleExtraEu: true
        };
    }

    buildPackage() {
        return {
            length: { value: '', class: null },
            height: { value: '', class: null },
            depth:  { value: '', class: null },
            weight: { value: '', class: null },
        }
    }

    buildPackageOptions(packages, index = 0) {
      
        let selectedDefaultValue;
        const packageOptions = packages?.map(((packageItem) => {
            if(packageItem.default) {
                selectedDefaultValue = {
                    text: packageItem.name,
                    value: packageItem.id
                }
            }
            return {
                text: packageItem.name,
                value: packageItem.id
            }
        }));

        if(!selectedDefaultValue) {
            selectedDefaultValue = {
                text: this.le.package.packageOptionDefaultValue,
                value: "-1"
            }
        }

        const selectedPackageFound = packages.find((item => item.id === selectedDefaultValue.value));
        const newData = this.setDefaultPackageValues(index, selectedPackageFound);

        return {
          packageOptions: {
            packageOptions,
            [index]: selectedDefaultValue,
          },
          data: newData,
       };
    }

    onPackageOptionChange(ev, packageIndex) {
        const selectedPackageId = ev.currentTarget.value;

        const selectedPackageFound = this.state.packageItems.find((item => item.id === selectedPackageId));
       
        const newData =  this.setDefaultPackageValues(packageIndex, selectedPackageFound);
        const defaultOption = {
            value: selectedPackageFound.id,
            text: selectedPackageFound.name
        }

        this.setState((prevState) => {
            const packageOptions = prevState.packageOptions[packageIndex] = defaultOption;
            return {
                data: newData,
                [packageOptions[packageIndex]]: packageOptions 
            }
        });
    }

    setDefaultPackageValues(packageIndex, selectedPackageFound) {
        const lengthValue = selectedPackageFound.length;
        const heightValue = selectedPackageFound.height;
        const depthValue = selectedPackageFound.depth;
        const weightValue = selectedPackageFound.weight;
        
        const newData = {...this.state.data};

        newData.package[packageIndex]['length'].value = lengthValue;
        newData.package[packageIndex]['height'].value = heightValue;
        newData.package[packageIndex]['depth'].value  = depthValue;
        newData.package[packageIndex]['weight'].value = weightValue;

        return newData;
    }

    addPackage(ev, index) {
        const newData = {...this.state.data};
        newData.package.push(this.buildPackage());
        const packageOptions = {...this.state.packageOptions};
        const newPackage = this.buildPackageOptions(this.state.packageItems, index);
        
        this.setState({
            data: newPackage.data,
            packageOptions: {...packageOptions, ...newPackage.packageOptions}
        });
    }

    removePackage(ev, index) {
        let data = {...this.state.data};
        data.package.splice(index, 1);
        const packageOptions = {...this.state.packageOptions};
        delete packageOptions[index];

        this.setState({
            data,
            packageOptions
        });
    }

    buildPostData() {
        let data = this.props.data;

        data.package = [];
        data.package.push(this.buildPackage());
        data.order.orderNum = "";
        data.order.carrierId = "";
        data.order.orderContentValueStr = '';
        data.order.orderContentDesc = '';
        data.order.orderContentDescCheck = false;
        if (this.uc && this.uc.organization && this.uc.organization == 'Leone89') {
            data.order.orderContentValueStr = '80';
            data.order.orderContentDesc = 'Gadget per feste, costumi e accessori';
            data.order.orderContentDescCheck = true;
        }
        return data;
    }
    
    validateForm(thePackage, sections, postData) {
        const {triangulation, sender, recipient } = postData;
        
        let isTriangulationChecked = false;

        const validation = [{
                fieldObject: postData.order,
                fieldName: 'orderNum',
                fieldValue: postData.order.orderNum,
                fieldError: 'orderNumError',
                validate: emptyValidation
            },
            {

                fieldObject: postData.order,
                fieldName: 'orderContentValue',
                fieldValue: postData.order.orderContentValueStr,
                fieldError: 'orderContentValueError',
                validate: numberValidation
            },
            {

                fieldObject: postData.order,
                fieldName: 'orderContentDesc',
                fieldValue: postData.order.orderContentDesc,
                fieldError: 'orderContentDescError',
                validate: emptyValidation
            },
           
             {
                 fieldObject: postData.order,
                 fieldName: 'orderContentDescCheck',
                 fieldValue: postData.order.orderContentDescCheck,
                 fieldError: 'orderContentDescCheckError',
                 validate: isTrueValidation
             }
        ];


        if(postData.services.triangulation.active) {
            isTriangulationChecked = true;
        }

        if (postData.services.assicurazione.active) {
            validation.push({
                fieldObject: postData.checkbox,
                fieldName: 'acceptance',
                fieldValue: postData.checkbox.acceptance,
                fieldError: 'error',
                validate: isTrueValidation
            });

            validation.push({
                fieldObject: postData.services.assicurazione,
                fieldName: 'assicurazione',
                fieldValue: postData.services.assicurazione.value,
                fieldError: 'error',
                validate: numberValidation
            });
        }
        if (postData.services.contrassegno.active) {
            validation.push({
                fieldObject: postData.services.contrassegno,
                fieldName: 'contrassegno',
                fieldValue: postData.services.contrassegno.value,
                fieldError: 'error',
                validate: numberValidation
            });
        }

        thePackage.forEach((val, idx) => {
            Object.entries(val).forEach(([key, val], idx) => {
                validation.push({
                        fieldObject: val,
                        fieldName: key,
                        fieldValue: val.value,
                        fieldError: 'error',
                    validate: numberValidation
                    });
            });
        });
        if(isTriangulationChecked) {
            Object.entries(triangulation).forEach(([key, val]) => {
                const  confIdx = sections[0].columns[0].items.findIndex((el) => (el.id === key));
                if (sections[0].columns[0].items[confIdx].hasOwnProperty("validate")  && sections[0].columns[0].items[confIdx].mandatory) {
                    if(key === 'zip') {
                        validation.push({
                            fieldObject: sections[0].columns[0].items[confIdx],
                            fieldName: key,
                            fieldValue: val,
                            fieldError: 'error',
                            countryName: triangulation.country,
                            validate: sections[0].columns[0].items[confIdx].validate
                        });
                    }else {
                        validation.push({
                            fieldObject: sections[0].columns[0].items[confIdx],
                            fieldName: key,
                            fieldValue: val,
                            fieldError: 'error',
                            validate: sections[0].columns[0].items[confIdx].validate
                        });
                    }
                    
                } 
            });
        }

        Object.entries(sender).forEach(([key, val], idx) => {
            const confIdx = sections[0].columns[1].items.findIndex((el) => (el.id === key));
            if (sections[0].columns[1].items[confIdx].hasOwnProperty("validate")) {
                if(key === 'zip') {
                    validation.push({
                        fieldObject: sections[0].columns[1].items[confIdx],
                        fieldName: key,
                        fieldValue: val,
                        fieldError: 'error',
                        countryName: "ITALIA",
                        validate: sections[0].columns[1].items[confIdx].validate
                    });
                } else {
                    validation.push({
                        fieldObject: sections[0].columns[1].items[confIdx],
                        fieldName: key,
                        fieldValue: val,
                        fieldError: 'error',
                        validate: sections[0].columns[1].items[confIdx].validate
                    });
                }
                
            }
        });


        Object.entries(recipient).forEach(([key, val]) => {
            const  confIdx = sections[0].columns[2].items.findIndex((el) => (el.id === key));
            if (sections[0].columns[2].items[confIdx].hasOwnProperty("validate") && sections[0].columns[2].items[confIdx].mandatory) {
                if(key === 'zip') {
                    validation.push({
                        fieldObject: sections[0].columns[2].items[confIdx],
                        fieldName: key,
                        fieldValue: val,
                        fieldError: 'error',
                        countryName: recipient.country,
                        validate: sections[0].columns[2].items[confIdx].validate
                    });
                } else {
                    validation.push({
                        fieldObject: sections[0].columns[2].items[confIdx],
                        fieldName: key,
                        fieldValue: val,
                        fieldError: 'error',
                        validate: sections[0].columns[2].items[confIdx].validate
                    });
                }
                
            }
        });

        if (validate(validation)) {
            let carrier = this.findCarrierById(postData.order.carrierId);
            let ret = validateCarrierRules(carrier, postData.order.orderNum, postData.package, postData.recipient.zip, postData.services.contrassegno && postData.services.contrassegno.active, postData.recipient.country);
            if (ret == null || ret.length == 0) {
                return true;
            }
            else {
                this.props.popupErrorMessage(ret);
                this.setState({ data: postData });
            }
        }
        else {
            this.props.popupErrorMessage(this.le.messages[2].messages[0]);
            this.setState({ data: postData });
        }
    } 

    findSenderWareHouseByName(name) {
        let wareh = this.state.senderWarehouses.find(a => a.name == name);
        if (wareh == undefined) {
            return null;
        }
        return wareh;
    }

    findCarrierById(id) {
        let carrier = this.state.carriers.find(a => a.carrierId == id);
        if (carrier == undefined) {
            return null;
        }
        return carrier;
    }

    findSenderWareHouseById(id) {
        let wareh = this.state.senderWarehouses.find(a => a.id == id);
        if (wareh == undefined) {
            return null;
        }
        return wareh;
    }


    buildSenderWareHouse(userPickupAddressDto) {
        return userPickupAddressDto;
    }

    findRecipientWareHouseById(id) {
        let wareh = this.state.recipientWarehouses.find(a => a.id == id);
        if (wareh == undefined) {
            return null;
        }
        return wareh;
    }

    buildRecipientWareHouse(userRecipientAddressDto) {
        return userRecipientAddressDto;
    }

    setSender(sender, warehouseId) {
        let wareh = this.findSenderWareHouseById(warehouseId);

        if (wareh != null) {
            sender.name = wareh.name;
            sender.surname = wareh.surname;
            sender.address = wareh.address;
            sender.houseNo = wareh.houseNo;
            sender.city = wareh.city;
            sender.province = wareh.province;
            sender.zip = wareh.zip;
            sender.number = wareh.phone;
            sender.email = wareh.email;
        }
        else {
            sender.name = '';
            sender.surname = '';
            sender.address = '';
            sender.houseNo = '';
            sender.city ='';
            sender.province = '';
            sender.zip = '';
            sender.number = '';
            sender.email = '';
        }
        return sender;
    }

    setRecipient(recipient, warehouseId) {
        let wareh = this.findRecipientWareHouseById(warehouseId);
        if (wareh != null) {
            recipient.name = wareh.name;
            recipient.surname = wareh.surname;
            recipient.address = wareh.address;
            recipient.houseNo = wareh.houseNo;
            recipient.city = wareh.city;
            recipient.country = wareh.nation.toUpperCase();
            recipient.province = wareh.province;
            recipient.zip = wareh.zip;
            recipient.number = wareh.phone;
            recipient.email = wareh.email;
        } else {
            recipient.name = '';
            recipient.surname = '';
            recipient.address = '';
            recipient.houseNo = '';
            recipient.country = 'ITALIA';
            recipient.city ='';
            recipient.province = '';
            recipient.zip = '';
            recipient.number = '';
            recipient.email = '';
        }
        return recipient;
    }

    orderCostCalculation() {
        try {
            this.props.loaderShow(1);
            let postData = JSON.parse(JSON.stringify(this.state.data));
            postData.package.forEach((val, idx) => {
                Object.keys(val).forEach(key => { val[key] = Number(val[key].value.replaceAll(',', '.')) });
                val.weightU = "kg";
                val.lengthU = "cm";
                val.heightU = "cm";
                val.depthU = "cm";
                val.dimU = "cm";
            });

            postData.services = Object.entries(postData.services).filter(([key, val]) => (val.active)).map(([key, val]) => (
                { service: key, insuredValue: val.value != null ? val.value : "0", pickupDate: (val.type === "date") ? val.value : null }
            ));
            postData.order.acceptance = postData.checkbox.acceptance;

            ajax(this, {
                method: 'post', url: '/api/order/order-carrier-cost-calculate', headers: { Authorization: 'Bearer ' + this.uc.jwtToken },
                data: postData
            },
                response => {
                    this.props.loaderHide();
                    this.carrierCostCalcDto = response.data.result.calc;

                    this.setState({ modalType: 4, modalMsg: '', msgNumber: 0 });
                },
                error => {
                    this.props.loaderHide();

                    let errMsg = error.hasOwnProperty("errorMessage")
                        ? error.errorMessage : this.leMain.messages.msgError.messages[0];

                    //this.setState({ modalType: 2, modalMsg: errMsg });
                    this.setState({modalType: 0, isVisibleExtraEu: true})

                    this.props.popupErrorMessage(errMsg);

                }
            );
        }
        catch (e) {
            this.props.loaderHide();
        }
    }


    sendOrder(orderCostCalculated) {
       
        try {
            if (this.uc.userProfile.hasCreditBox && !orderCostCalculated) {
                this.orderCostCalculation();
                return;
            }
            this.props.loaderShow(1);
            let postData = JSON.parse(JSON.stringify(this.state.data));
            postData.package.forEach((val, idx) => {
                Object.keys(val).forEach(key => { val[key] = Number(val[key].value.replaceAll(',', '.')) });
                val.weightU = "kg";
                val.lengthU = "cm";
                val.heightU = "cm"; 
                val.depthU = "cm";
                val.dimU = "cm";
            });
           
            postData.services = Object.entries(postData.services).filter(([key, val]) => (val.active)).map(([key, val]) => (
                { service: key, insuredValue: val.value != null ? val.value: "0", pickupDate: (val.type === "date") ? val.value : null }
            ));

            postData.order.acceptance = postData.checkbox.acceptance;
           
            ajax(this, { method: 'post', url: '/api/order', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
                ()  => {
                    this.props.loaderHide();
                    const resetReturnedOrder = this.resetReturnedOrdersData();
                    resetReturnedOrder.package = this.resetPackages();
                    this.setState({
                        data: resetReturnedOrder
                    });
                   
                    this.setState({
                        modalType: 3,
                        modalMsg: '',
                        msgNumber: 0,
                        // data: this.buildPostData(),
                        data: resetReturnedOrder
                    });

                    this.props.history.replace("/orders-2");
                },
                error => {
                    this.props.loaderHide();

                    let errMsg = error.hasOwnProperty("errorMessage")
                        ? error.errorMessage
                        : this.leMain.messages.msgError.messages[0];

                    this.setState({ modalType: 0, modalMsg: "" });

                    this.props.popupErrorMessage(errMsg);
                }
            );
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    resetReturnedOrdersData() {
        const newOrderData = {...this.state.data}
        this.inputBoxes[0].columns[1].items[0].disabled = false;

        //order
        newOrderData.order.orderNum  = ""
        newOrderData.order.carrierId  = "";
        newOrderData.order.orderContentDesc = "";
        newOrderData.order.orderContentDescCheck = "";
        newOrderData.order.orderContentValueStr = "";
        //sender
        newOrderData.sender.name = "";
        newOrderData.sender.surname = "";
        newOrderData.sender.number = "";
        newOrderData.sender.city = "";
        newOrderData.sender.province = "";
        newOrderData.sender.zip = "";
        newOrderData.sender.address = "";
        newOrderData.sender.houseNo = "";
        newOrderData.sender.at = "";
        newOrderData.sender.email = "";
        newOrderData.sender.note = "";

        //receiver
        newOrderData.recipient.name = "";
        newOrderData.recipient.surname = "";
        newOrderData.recipient.number = "";
        newOrderData.recipient.city = "";
        newOrderData.recipient.province = "";
        newOrderData.recipient.zip = "";
        newOrderData.recipient.address = "";
        newOrderData.recipient.houseNo = "";
        newOrderData.recipient.at = ""
        newOrderData.recipient.email = "";
        newOrderData.recipient.note = "";


        return newOrderData;

    }

    resetPackages() {

        const defaultPackages = [
            {
                weight: { value:  "", class: null },
                height: { value: "", class: null },
                length: { value: "", class: null },
                depth:  { value: "", class: null },
            }
        ];


        return defaultPackages;

    }

    setReturnedOrdersData(returnedOrders) {
        const returnedOrderData = returnedOrders.result.order;
        const newOrderData = {...this.state.data}
       
        const newData = {...this.state.data};

        returnedOrderData.returnedOrderPackages.forEach((pack, index) => {
            if(returnedOrderData.returnedOrderPackages.length !== newData.package.length) {
                this.addPackage("", index + 1)
            }
        });

        returnedOrderData.returnedOrderPackages.forEach((pack, index) => {
            newData.package[index] = {
                weight: { value:  pack.weight, class: null },
                height: { value: pack.height, class: null },
                length: { value: pack.width, class: null },
                depth:  { value: pack.depth, class: null },
            };
        });


        

        newOrderData.order.returned = returnedOrderData.returned;
        newOrderData.order.orderReturned = returnedOrderData.orderReturned;
        //Order
        newOrderData.order.orderNum  = returnedOrderData.orderNum;
        newOrderData.order.carrierId  = returnedOrderData.carrierId;
        newOrderData.order.orderContentDesc = returnedOrderData.orderContentDesc;
        newOrderData.order.orderContentDescCheck = returnedOrderData.orderContentDescCheck;
        newOrderData.order.orderContentValueStr = returnedOrderData.orderContentValueStr;
        
        //sender
        this.inputBoxes[0].columns[1].items[0].disabled = true;
        newOrderData.sender.name = returnedOrderData.orderSender.name;
        newOrderData.sender.surname = returnedOrderData.orderSender.surname;
        newOrderData.sender.number = returnedOrderData.orderSender.number;
        newOrderData.sender.city = returnedOrderData.orderSender.city;
        newOrderData.sender.province = returnedOrderData.orderSender.province;
        newOrderData.sender.zip = returnedOrderData.orderSender.zip;
        newOrderData.sender.address = returnedOrderData.orderSender.address;
        newOrderData.sender.houseNo = returnedOrderData.orderSender.houseNo;
        newOrderData.sender.at = returnedOrderData.orderSender.at;
        newOrderData.sender.email = returnedOrderData.orderSender.email;
        newOrderData.sender.note = returnedOrderData.orderSender.note;

        //receiver
        newOrderData.recipient.name = returnedOrderData.orderRecipient.name;
        newOrderData.recipient.surname = returnedOrderData.orderRecipient.surname;
        newOrderData.recipient.number = returnedOrderData.orderRecipient.number;
        newOrderData.recipient.city = returnedOrderData.orderRecipient.city;
        newOrderData.recipient.province = returnedOrderData.orderRecipient.province;
        newOrderData.recipient.zip = returnedOrderData.orderRecipient.zip;
        newOrderData.recipient.address = returnedOrderData.orderRecipient.address;
        newOrderData.recipient.houseNo = returnedOrderData.orderRecipient.houseNo;
        newOrderData.recipient.at = returnedOrderData.orderRecipient.at;
        newOrderData.recipient.email = returnedOrderData.orderRecipient.email;
        newOrderData.recipient.note = returnedOrderData.orderRecipient.note;

        return newOrderData;

    }

    componentDidMount() {
        const orderId = new URLSearchParams(this.location.search).get("orderId");
        if(orderId) {
            loadReturnedOrders(orderId, this.uc.jwtToken,
                returnedOrders => {
                    const newOrderData = this.setReturnedOrdersData(returnedOrders);

                    this.setState({
                        data: newOrderData
                    });
                },
                ko => { },
                this
            );
        }
        loadPickUpAddress(this.uc.jwtToken,
            adresses => {
                let senderWarehouses = [];
                const sections = this.inputBoxes[0];
                adresses.map((el, idx) => {
                    let wareh = this.buildSenderWareHouse(el);
                    senderWarehouses.push(wareh);
                });
                
                let pickup = sections.columns[1].items.find(el => el.id == 'selectedPickup');

                if (pickup != undefined) {
                    senderWarehouses.forEach((val, idx) => {
                        let opt = { text: val.identifier,value:val.id};
                        pickup.options.push(opt);
                    });
                }
                this.setState({ senderWarehouses: senderWarehouses });
            },
            ko => { },
            this
        );


        loadUPSProvinceCodes(canadaCountryCode, this.uc.jwtToken,
            canadaProvinceCodes => {
                const modifiedCanadaProvinceCodes = ["", ...canadaProvinceCodes];
                const newCanadaProvinceCodes = modifiedCanadaProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                });
                this.setState({
                    newCanadaProvinceCodes
                })
            },
            ko => { },
            this
        );

        loadUPSProvinceCodes(USCountryCode, this.uc.jwtToken,
            usProvinceCodes => {
                const modifiedUSProvinceCodes = ["", ...usProvinceCodes];
                const newUSProvinceCodes = modifiedUSProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                })
                this.setState({
                    newUSProvinceCodes
                })
               
            },
            ko => { },
            this
        );

        loadRecipientAddresses(this.uc.jwtToken,
            adresses => {
                let recipientWarehouses = [];
                const sections = this.inputBoxes[0];
                adresses.map((el, idx) => {
                    let wareh = this.buildRecipientWareHouse(el);
                    recipientWarehouses.push(wareh);
                });
                
                let recipient = sections.columns[2].items.find(el => el.id == 'selectedPickup');

                if (recipient != undefined) {
                    recipientWarehouses.forEach((val, idx) => {
                        let opt = { text: val.identifier,value:val.id};
                        recipient.options.push(opt);
                    });
                }
                this.setState({ recipientWarehouses: recipientWarehouses });
            },
            ko => { },
            this
        );
        loadOrderServices(null, this.uc.jwtToken,
            services => {
                const servicesData = services.result.services;
                const checkboxAssuranceVal = servicesData.chkAssurance.val;
                const checkboxTriangulationVal = servicesData.chkTriangulation.val;
                const newServiceData = {...this.state.data}
                newServiceData.services.assicurazione.active = checkboxAssuranceVal;
                newServiceData.services.triangulation.active = checkboxTriangulationVal;
                this.setState({
                    data: newServiceData
                });
            },
            ko => { },
            this
        );

        loadAutocompleteCountries(this.uc.jwtToken, (countries) => {
            this.setState({
                countries: countries
            });
        },
        ko => { },
        this);

        loadCarrierSets(this.uc.jwtToken,
            carriers => {
                let newData = JSON.parse(JSON.stringify(this.state.data));

                if (carriers.length > 0) {
                    if(!orderId) {
                        newData.order.carrierId = carriers[0].carrierId;
                        newData.order.name = carriers[0].name;
                    }
                    if (carriers[0].counterSign) {
                        newData.services.contrassegno.enabled = true;
                    } 
                    if (carriers[0].triangulation){
                        newData.services.triangulation.enabled = true;
                    }

                    if (!carriers[0].triangulation){
                        newData.services.triangulation.enabled = false;
                    }

                    if(!carriers[0].counterSign){
                        newData.services.contrassegno.enabled = false;
                    } 
                }   
                this.setState({ carriers: carriers, data: newData});
            },
            ko => { },
        this);

        

        loadPackageConfig(this.uc.jwtToken,
            packages => {
                const firstOption = {
                    default: false,
                    name: this.le.package.packageOptionDefaultValue,
                    depth: "",
                    id: "-1",
                    height: "",
                    length: "",
                    weight: ""
                }

                const packagesModified = [firstOption, ...packages];
                const packageOptions = this.buildPackageOptions(packagesModified);
                this.setState({ 
                    packageItems: packagesModified,
                    packageOptions: packageOptions.packageOptions,
                    data: packageOptions.data
                 });
            },
            () => {},
            this);
    }

    componentDidUpdate(prevProps) {
        const prevOrderId = prevProps.location.search;
        const currentOrderId = this.props.location.search;

        if ((prevOrderId && !currentOrderId)) {
            const resetReturnedOrder = this.resetReturnedOrdersData();
            this.setState({
                data: resetReturnedOrder
            });
        } 
    }

    confirmOrder() {
        this.sendOrder(false);
    }

    createOrder(ev, data, orderCostCalculated) {
        let postData = this.state.data;
        if(this.validateForm(postData.package, this.inputBoxes, postData)) {
            if(!this.state.isSelectedRecipientCountryEu && this.state.isVisibleExtraEu) {
                this.setState({ modalType: 5, modalMsg: '', msgNumber: 0, isVisibleExtraEu: false });
                return;
            }
            this.sendOrder(orderCostCalculated);
        }
    }

    packageChange(ev, index) {
        let name = ev.target.name;
        let val = ev.target.value;
        let newData = {...this.state.data};
        newData.package[index][name].value = val;
        this.setState({ data: newData });
    }

    orderChange(ev) {
        let name = ev.target.name;
        let val = ev.target.type == 'checkbox' ? ev.target.checked : ev.target.value;
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData.order[name] = val;

        const who = ['inputs', 2, 6];
        const sections = this.inputBoxes[0];
        const column = sections.columns[who[1]].id;
        if (name === 'carrierId') {
            let carrier = this.findCarrierById(val);
            newData.order["name"] = carrier.name;
            newData.services["triangulation"].active = false;
            newData.services["contrassegno"].active = false;
            if (carrier != null && carrier.counterSign) {
                newData.services.contrassegno.enabled = true;
            }
            if(carrier != null && !carrier.counterSign) {
                newData.services.contrassegno.enabled = false;
                newData.services["contrassegno"].value = "";
            }

            if (carrier != null && carrier.triangulation) {
                newData.services.triangulation.enabled = true;
            }
           
            if(carrier != null && !carrier.triangulation) {
                newData.services.triangulation.enabled = false;
                newData.triangulation = this.resetTriangulationFields();
            }
            if(this.state.countryCode[who[1]] === canadaCountryCode && carrier.name === UPSCourier) {
                this.changeProvinceFieldType(who, this.state.newCanadaProvinceCodes);
            } else if(this.state.countryCode[2] === USCountryCode && carrier.name === UPSCourier) {
                this.changeProvinceFieldType(who, this.state.newUSProvinceCodes);
            } else {
                this.changeProvinceFieldType(who, [], "text");
                newData[column]['province'] = '';
                this.togglePropertyField({
                    who,
                    fieldName: 'province',
                    booleanValue: false,
                    propertyName: 'mandatory' 
                });
            }
        }
        this.setState({
            data: newData,
            showTriangolationSection: false
        });
    }

    resetTriangulationFields() {
        const trinagulationFields = {
            address: "",
            at: "",
            city: "",
            country: "ITALIA",
            houseNo: "",
            name: "",
            number: "",
            province: "",
            surname: "",
            zip: ""
        }

        return trinagulationFields;
    }
    
    serviceChange(ev) {
        let name = ev.target.name;
        let val = ev.target.type == 'checkbox' ? ev.target.checked : ev.target.value;
        let newData = {...this.state.data};

        if(name === 'triangulation') {
            newData.services[name].active = val;
            newData.triangulation = this.resetTriangulationFields();
            this.setState((prevState) => {
                return {
                    data: newData,
                    showTriangolationSection: !prevState.showTriangolationSection
                }
            });
            return
        }


        if (newData.checkbox.hasOwnProperty(name)) {
            newData.checkbox[name] = val;
        }
        else if (ev.target.type == 'checkbox') {
            newData.services[name].active = val;
            if (!val) {
                newData.services[name].value = '';
            }
        }
        else {
            newData.services[name].value = val;
        }
        this.setState({ data: newData });
    }

    removeFieldErrors(who, fieldNames) {
        const columnItems =  this.inputBoxes[0].columns[who[1]].items;
        const foundItem = columnItems.find(item => item.id === fieldNames);
        // if(Object.hasOwn(foundItem, "error")) {
        //     delete foundItem.error;
        // }
     


        if(typeof fieldNames == 'object') {
            for(let fieldName of fieldNames) {
                const foundItem = columnItems.find(item => item.id === fieldName);
                if(Object.hasOwn(foundItem, "error")) {
                    delete foundItem.error;
                }
            }
        } else {
            if(Object.hasOwn(foundItem, "error")) {
                delete foundItem.error;
            }
        }

        const foundItemIndex = columnItems.findIndex(item => item.id === fieldNames);

        this.inputBoxes[0].columns[who[1]].items[foundItemIndex] = foundItem;
    }

    addressChange(ev, who, value) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        const sections = this.inputBoxes[0];
        const column = sections.columns[who[1]].id;
        const field = sections.columns[who[1]].items[who[2]].id;
        let selectedCountryCode = "IT";
        let isSelectedRecipientCountryEu = true;
        let isVisibleExtraEu = true;
        newData[column][field] = value;

        if (field == 'selectedPickup' && column === 'sender') {
            this.setSender(newData[column], value);
        } else if(field == 'selectedPickup' && column === 'recipient') {
            const recipient = this.setRecipient(newData[column], value);
            const selectedCountry = this.state.countries.find((country) => country.name === recipient.country);
            selectedCountryCode = selectedCountry.code;
            isSelectedRecipientCountryEu = selectedCountry.eu;
            isVisibleExtraEu = selectedCountry.is_visible_extra_eu

            if(selectedCountryCode === canadaCountryCode && this.state.data.order.name === UPSCourier) {
                this.changeProvinceFieldType(who, this.state.newCanadaProvinceCodes);
            } else if (selectedCountryCode === USCountryCode && this.state.data.order.name === UPSCourier) {
                this.changeProvinceFieldType(who, this.state.newUSProvinceCodes);
            } else {
                const items = {
                    cityName:  recipient.city,
                    provinceCode: recipient.province,
                    zipCode: recipient.zip,
                }

                this.changeProvinceFieldType(who, [], "text");
    
                newData[column]['city'] = this.getCityName(items);
                newData[column]['province'] = this.getProvinceName(items);
                newData[column]['zip'] = this.getZipCode(items);
                this.toggleProvinceAndZipMandatoryFields(who, items);
            }


            this.togglePropertyField({
                who,
                fieldName: 'province',
                booleanValue: false,
                propertyName: "disabled" 
            });
    
            this.togglePropertyField({
                who,
                fieldName: 'zip',
                booleanValue: false,
                propertyName: "disabled" 
            });
            this.setState({ 
                data: newData, 
                countryCode: {
                    [who[1]]: selectedCountryCode
                },
                isSelectedRecipientCountryEu,
                isVisibleExtraEu
            });
            return
        }else if (field === "province"  && column === 'recipient') {
            newData[column]['province'] = value;
        }
        this.removeFieldErrors(who, field);
        this.setState({ data: newData});
    }

    dataChange(ev) {
        let name = ev.target.name;
        let val = ev.target.type == 'checkbox' ? ev.target.checked : ev.target.value;
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData.order[name] = val;

        if (name === 'carrierId') {
            let carrier = this.findCarrierById(val);
            if (carrier != null && carrier.counterSign) {
                newData.services.contrassegno.enabled = true;
            } else {
                newData.services.contrassegno.enabled = false;
            }
        }

        this.setState({ data: newData });
    }

    autocompletePlaceSelected(who, place, dict) {
        const sections = this.inputBoxes[0];
        const column = sections.columns[who[1]].id;

        if (dict) {
            let newData = JSON.parse(JSON.stringify(this.state.data));
            newData[column]['address'] = dict.route ? dict.route : '';
            newData[column]['houseNo'] = dict.street_number ? dict.street_number : '';
            newData[column]['city'] = dict.locality ? dict.locality :'';
            newData[column]['province'] = dict.administrative_area_level_2 ? dict.administrative_area_level_2 : '';
            newData[column]['zip'] = dict.postal_code ? dict.postal_code : '';
            this.setState({ data: newData });
        }
    }

    togglePropertyField({ who, fieldName, booleanValue, propertyName}) {
        const columnItems =  this.inputBoxes[0].columns[who[1]].items;
        const foundItem = columnItems.find(item => item.id === fieldName);
        const foundItemIndex = columnItems.findIndex(item => item.id === fieldName);
        foundItem[propertyName] = booleanValue;
        this.inputBoxes[0].columns[who[1]].items[foundItemIndex] = foundItem;
    }

    resetCityProvinceZipField(column, who, value, booleanValue) {
        column['country'] = value;
        column['city'] = '';
        column['province'] = '';
        column['zip'] = '';

        this.togglePropertyField({
            who,
            fieldName: 'city',
            booleanValue: booleanValue,
            propertyName: 'disabled' 
        });
        this.togglePropertyField({
            who,
            fieldName: 'province',
            booleanValue: booleanValue,
            propertyName: 'disabled' 
        });

        this.togglePropertyField({
            who,
            fieldName: 'zip',
            booleanValue: booleanValue,
            propertyName: 'disabled' 
        });
    }

    //who, countryName,  countryCode, source
    onAutocompleteCountryChange(who, value, countryCode, source, isCountryEu, isVisibleExtraEu) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        const sections = this.inputBoxes[0];
        const column = sections.columns[who[1]].id;
        const field = sections.columns[who[1]].items[who[2]].id;

        newData[column][field] = value;

        
        
        this.resetCityProvinceZipField(newData[column], who, value, false);
        if(countryCode === canadaCountryCode && this.state.data.order.name === UPSCourier) {
            this.changeProvinceFieldType(who, this.state.newCanadaProvinceCodes);
         } else if(countryCode === USCountryCode && this.state.data.order.name === UPSCourier) {
             this.changeProvinceFieldType(who, this.state.newUSProvinceCodes);
         }else {
             this.changeProvinceFieldType(who, [],  "text");
         }
        this.togglePropertyField({
            who,
            fieldName: 'province',
            booleanValue: true,
            propertyName: "disabled" 
        });
        
        this.togglePropertyField({
            who,
            fieldName: 'zip',
            booleanValue: true,
            propertyName: "disabled" 
        });
        
        if(source === 'recipient') {
            this.setState((prevState) => {
                return {
                    data: newData,
                    countryCode: {
                        [who[1]]: countryCode
                    },
                    suggestedCountry: {
                        ...prevState.suggestedCountry,
                        [who[1]]: [...this.state.countries]
                    },
                    suggestedCity: {
                        ...prevState.suggestedCity,
                        [who[1]]: []
                    },
                    isSelectedRecipientCountryEu: isCountryEu,
                    isVisibleExtraEu: isVisibleExtraEu
                }
            });
            return
        }

        this.setState((prevState) => {
            return {
                data: newData,
                countryCode: {
                    [who[1]]: countryCode
                },
                suggestedCountry: {
                    ...prevState.suggestedCountry,
                    [who[1]]: [...this.state.countries]
                },
                suggestedCity: {
                    ...prevState.suggestedCity,
                    [who[1]]: []
                }
            }
        });
    }

    onAutocompleteCountrySelected(who, value, countryCode) {
        // let newData = JSON.parse(JSON.stringify(this.state.data));
        // const column = this.inputBoxes[0].columns[who[1]].id;
        // this.resetCityProvinceZipField(newData[column], who, value, false);

        // this.setState((prevState) => {
        //     return {
        //         data: newData,
        //         countryCode: {
        //             [who[1]]: countryCode
        //         },
        //         suggestedCity: {
        //             ...prevState.suggestedCity,
        //             [who[1]]: [...this.state.countries]
        //         }
        //     }
        // });
    }

    toggleProvinceAndZipMandatoryFields(who, items) {
        if(!this.getProvinceName(items)) {
            this.togglePropertyField({
              who,
              fieldName: 'province',
              booleanValue: false,
              propertyName: "mandatory" 
            });
          } else {
              this.togglePropertyField({
                  who,
                  fieldName: 'province',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
  
          if(!this.getZipCode(items)) {
              this.togglePropertyField({
                  who,
                  fieldName: 'zip',
                  booleanValue: false,
                  propertyName: "mandatory" 
              });
            } else {
              this.togglePropertyField({
                  who,
                  fieldName: 'zip',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
    }

    onAutocompleteCityChange(who,  value ) {
        let newData = {...this.state.data};
        const column = this.inputBoxes[0].columns[who[1]].id;
        const field = this.inputBoxes[0].columns[who[1]].items[who[2]].id;
        newData[column][field] = value;
        const countryCode = this.state.countryCode[who[1]];
        let suggested = [];
        if (value.length >= 2 && ((countryCode && column === 'recipient') || (countryCode && column === 'triangulation'))) {
            (autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value,
                countryCode,
                response => {
                    response.forEach((el) => {
                        suggested.push({
                            id: el.id,
                            label: el.label,
                            labelShort:el.labelShort, 
                            cityName: el.cityName,
                            provinceCode: el.provinceCode,
                            zipCode: el.value
                        }); 
                    });
                    
                    this.setState(prevState => {
                        const prevSuggestedCity = {
                            ...prevState.suggestedCity
                        };
                        prevSuggestedCity[who[1]] = suggested;
                        return  {
                            data: newData,
                            suggestedCity: {
                                ...prevState.suggestedCity,
                                [who[1]]: suggested
                            }
                         }
                    })
                }));
        } 
        else if(value.length >= 2 && column === 'sender') {
            autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value, "IT",
                response => {
                    response.map((el) => { 
                        suggested.push({
                            id: el.id,
                            label: el.label,
                            labelShort:el.labelShort, 
                            cityName: el.cityName,
                            provinceCode: el.provinceCode,
                            zipCode: el.value
                        }); 
                    });
                    this.setState(prevState => {
                        const prevSuggestedCity = {
                            ...prevState.suggestedCity
                        };
                        prevSuggestedCity[who[1]] = suggested;
                        return  {
                            data: newData,
                            suggestedCity: {
                                ...prevState.suggestedCity,
                                [who[1]]: suggested
                            }
                         }
                    })
                });
        }
        else {
            this.state.suggestedCity[who[1]] = suggested;
            this.setState({ data: newData, suggestedCity: {0: [], 1: [], 2: []} });
        }
    }

    changeProvinceFieldType(who, optionState, type = "select") {
        const columnItems =  this.inputBoxes[0].columns[who[1]].items;
            const foundItem = columnItems.find(item => item.id === 'province');
            const foundItemIndex = columnItems.findIndex(item => item.id === 'province');
            foundItem["type"] = type;
            foundItem["options"] = optionState;
            

            
            this.inputBoxes[0].columns[who[1]].items[foundItemIndex] = foundItem;
            this.togglePropertyField({
                who,
                fieldName: 'province',
                booleanValue: true,
                propertyName: "mandatory" 
            });
    }
    
    onAutocompleteCitySelected(who, items) {
        let newData = JSON.parse(JSON.stringify(this.state.data));
        const column = this.inputBoxes[0].columns[who[1]].id;
        newData[column]['city'] = this.getCityName(items);
        newData[column]['province'] = this.getProvinceName(items);
        newData[column]['zip'] = this.getZipCode(items);

        this.toggleProvinceAndZipMandatoryFields(who, items);


        if((this.state.countryCode[2] === canadaCountryCode && this.state.data.order.name === UPSCourier) 
            || (this.state.countryCode[2] === USCountryCode && this.state.data.order.name === UPSCourier)) {
            this.togglePropertyField({
                who,
                fieldName: 'province',
                booleanValue: true,
                propertyName: "mandatory" 
            });
        }

        this.togglePropertyField({
            who,
            fieldName: 'province',
            booleanValue: false,
            propertyName: "disabled" 
        });

        this.togglePropertyField({
            who,
            fieldName: 'zip',
            booleanValue: false,
            propertyName: "disabled" 
        });

        this.removeFieldErrors(who, ['city', 'province', 'zip']);

        
        this.setState({ data: newData });
    }

    getCityName(cityObject) {
        const cityName = cityObject?.cityName;
        const labelShort = cityObject?.labelShort || "";
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return cityName;
        }


        if(zipCode && zipCode.length > 0) {
            return labelShort.split(zipCode)[0].trim()
        }

        if(!cityName) {
            return labelShort.trim();
        }

        if(zipCode && zipCode.length === 0) {
            return ''
        }
    }

    getProvinceName(cityObject) {
        const cityName = cityObject?.cityName;
        const provinceCode = cityObject?.provinceCode;
        if(cityName) {
            return provinceCode;
        }

        if(!cityName && provinceCode) {
            return provinceCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    getZipCode(cityObject) {
        const cityName = cityObject?.cityName;
        const provinceCode = cityObject?.provinceCode;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return zipCode;
        }

        if(!cityName && zipCode) {
            return zipCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    warehouseSenderChange(ev) {
        this.setState({ modalSel: ev.target.name });
    }

    warehouseSenderClick(ev, save) {
        if (save) {
            let postData = JSON.parse(JSON.stringify(this.state.data));
            Object.keys(postData.package).forEach(key => { postData.package[key] = Number(postData.package[key].value); });
            postData.package.weightU = "kg";
            postData.package.lengthU = "cm";
            postData.package.heightU = "cm";
            postData.package.depthU = "cm";
            postData.package.dimU = "cm";
            postData.services = Object.entries(postData.services).filter(([key, val]) => (val.active)).map(([key, val]) => (
                { service: key, insuredValue: (val.type === "text") ? val.value : null, pickupDate: (val.type === "date") ? val.value : null }
            ));
            Object.keys(postData.services).forEach(key => { postData.services[key] = postData.services[key].value; });
            //postData.order = { orderNum: postData.orderNum, acceptance: postData.checkbox.acceptance };
            postData.order.acceptance = postData.checkbox.acceptance;
            //let wareh = this.findSenderWareHouseByName(this.state.modalSel);
            //if (wareh != null)
               // postData.warehouse = wareh.id;

            //delete postData.checkbox;
            ajax(this, { method: 'post', url: '/api/order', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: postData },
                response => {
                    this.setState({ modalType: 3, modalMsg: '', msgNumber: 0 });
                },
                error => {
                    this.setState({ modalType: 2, modalMsg: error.message });
                }
            );
        }
        this.setState({ modalType: 0 });
    }

    carrierCostModalAction(action) {
        let creditBoxOrderFrom = this.state.creditBoxOrderFrom;
        this.setState({ modalType: 0, creditBoxOrderFrom: '' });
        switch (action) {
            case "dismiss":
                this.setState({ modalType: 0, modalMsg: "", isVisibleExtraEu: true });
                break;
            case "accept":
                this.setState({ modalType: 0, modalMsg: "" });
                this.createOrder(null, null, true);
                break;
            case "buy":
                this.setState({ modalType: 0, modalMsg: "" });
                this.props.navigateTo("CREDITBOXMANAGE");
                break;
            default:
                this.setState({ modalType: 0, modalMsg: "", isVisibleExtraEu: true });
                break;

        }
    }

    closeOrderOkModal(ev) {
        this.setState({ modalType: 0, modalMsg: "" });
        this.props.navigateTo("ORDERLIST");
    }

    closeModal(ev) {
        this.setState({ modalType: 0, modalMsg: "" });
    }

    render() {
        //#region Data Structures
        let sections = [...this.inputBoxes];

        Object.entries(this.state.data.triangulation).forEach(([key, val], idx) => {
            const confIdx = sections[0].columns[0].items.findIndex((el) => (el.id === key));
            sections[0].columns[0].items[confIdx].value = val;
        });


        Object.entries(this.state.data.sender).forEach(([key, val], idx) => {
            const confIdx = sections[0].columns[1].items.findIndex((el) => (el.id === key));
            sections[0].columns[1].items[confIdx].value = val;
        });

        Object.entries(this.state.data.recipient).forEach(([key, val], idx) => {
            const confIdx = sections[0].columns[2].items.findIndex((el) => (el.id === key));
            sections[0].columns[2].items[confIdx].value = val;
            
        });

        sections[0].columns[0].items[4].options = this.state.suggestedCity[0];
        // sections[0].columns[0].items[3].options = this.state.suggestedCountry[0];
        sections[0].columns[0].items[3].options = this.state.countries;



        sections[0].columns[1].items[4].options = this.state.suggestedCity[1];
        
        // sections[0].columns[2].items[3].options = this.state.suggestedCountry[2];
        sections[0].columns[2].items[4].options = this.state.countries;
        sections[0].columns[2].items[5].options = this.state.suggestedCity[2] ;

        const reactSections = sections.map((el, idx) => {
            return (<InputSection
                key={"isec-" + idx}
                shouldShowTriangolationSection={this.state.showTriangolationSection}
                section={el.id}
                data={el}
                splitColumns={true}
                onAutocompleteSelected={this.onAutocompleteCitySelected}
                onAutocompleteChange={this.onAutocompleteCityChange}
                onAutocompletePlaceSelected={this.autocompletePlaceSelected}
                onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                onAutocompleteCountrySelected={this.onAutocompleteCountrySelected}
                onChange={this.addressChange} />)
        }, this);


        const carrierSelectOptions = this.state.carriers.map((el, idx) => {
            return { text: el.name, value: el.carrierId};
        },this);

        //#endregion Data Structures

        let modal;
        switch (this.state.modalType) {
            case 1:
                // PARE CASO NON PIU ESISTENTE...
                const le = this.le.senderWarehouses;
                const childs = this.state.senderWarehouses.map((el, idx) => {
                    const texts = [le.word + " " + el.name, el.address], value = (el.name === this.state.modalSel);
                    let rows = [<URadioComplex key={"radio-" + idx} name={el.name} group="senderWarehouses" value={value} text={texts} onChange={this.warehouseSenderChange} />];
                    rows.push(<div key={"sep-" + idx} style={{ marginTop: "1.5rem" }} />);
                    return rows;
                }, this);

                const buttons = [<UIButton text={le.button} onClick={(ev) => this.warehouseSenderClick(ev, true)} onCancel={(ev) => this.warehouseSenderClick(ev,false)} className="confirm" />];
                modal = <UIPopup title={le.title} buttons={buttons} onCancel={(ev) => (this.Click(ev, false))}>
                    {childs}
                </UIPopup>
                break;
            case 2:
            case 3:
                const msg = this.le.messages[this.state.modalType - 2];
                modal = <UIMessageBox
                    type="info"
                    title={msg.captions}
                    message={this.state.modalMsg || msg.messages[0]}>
                    <UIButton key="btn-0" className="confirm" text={msg.button} onClick={this.state.modalType == 3 ? this.closeOrderOkModal : this.closeModal} />
                </UIMessageBox>
                break;

            case 4:
                modal = (<OrderCostMessage onAction={this.carrierCostModalAction} carrierCostCalcDto={this.carrierCostCalcDto} />);
                break;
            case 5:
                const message = this.le.messages[this.state.modalType - 2];
                modal = <UIMessageBox
                    type="info"
                    title={message.captions}
                    message={this.state.modalMsg || message.messages}>
                    <UIButton key="btn-0" className="confirm" text={message.button} onClick={this.confirmOrder} />
                </UIMessageBox>
                break;
            default:
                modal = (<div />);
                break;
        }

        let packageRows = [], packageCols = [];

        let i = 0;
        for (i = 0; i < this.state.data.package.length;i++) {

            let packageData = Object.entries(this.state.data.package[i]).map(([key, obj], idx) => (
                Object.assign({ id: key, item: key, text: this.le.package.inputs[idx], type: 'text' }, obj)
            ), this);

            const title = (!packageRows.length && !packageCols.length) ? this.le.package.title + " " + (i + 1) : {
                text: this.le.package.title + " " + (i + 1),
                class: "bold upper blue",
                action: { text: this.le.package.removePackage, class: "blue right clickable", click: this.removePackage },
                element: null
            };

            packageCols.push(
                <div key={"col-"+i} className="col no-padding">
                    <SingleOrderPackage size="10" title={title} name={"package." + i} data={packageData} onChange={this.dataChange} />
                </div>
            );
            if (packageCols.length === 2) {
                if (packageRows.length) packageRows.push(<div key={"sepa-" + packageRows.length} style={{ marginTop: "3rem" }} />);
                packageRows.push(<div key={"row-" + packageRows.length} className="row">{packageCols}</div>);
                packageCols = [];
            }
        }

        let packageConf = Object.entries(this.state.data.package[0]).map(([key, obj], idx) => (
            { id: key, item: key, text: this.le.package.inputs[idx], type: 'text', value: "", class: obj.class }
        ), this);

        packageCols.push(
            <div key={"col-void"} className="col no-padding">
                <SingleOrderPackage disabled={true} size="10" 
                    name="packageConf" data={packageConf} onChange={this.dataChange}
                    title={{ action: { text: this.le.package.addPackage, class: "bold blue upper clickable", click: this.addPackage }, element: "../images/circledPlus.png" }}
                />
            </div>
        );

        if (packageCols.length < 2) {
            packageCols.push(<div key="col-filler" className="col no-padding" />);
        }
        if (packageRows.length) {
            packageRows.push(<div key={"sepa-" + packageRows.length} style={{ marginTop: "3rem" }} />);
        }

        packageRows.push(<div key="row-void" className="row">{packageCols}</div>);

        let packageContainer = [];
        packageContainer.push(
            <div key="row-void" className="row">
                <div className="col-10">
                    {packageRows}
                </div>
            </div >);

        let packageLanguageConfig = Languages.getSection('OrderCreation').manage.package;

        let packages = this.state.data.package.map((pack, index) => (
            <UIOrderPackageConfig
                key={index}
                title={packageLanguageConfig.title + (index + 1)}
                texts={packageLanguageConfig}
                data={Object.entries(pack).map(([key, obj], idx) => (
                    Object.assign({
                        id: key,
                        item: key,
                        text: packageLanguageConfig.inputs[idx],
                        unit: packageLanguageConfig.units[idx],
                        type: 'text'
                    }, obj)
                ), this)}
                packageOptions={this.state.packageOptions.packageOptions}
                packageOptionValue={this.state.packageOptions[index]}
                onAdd={index == this.state.data.package.length - 1 && ((ev) => (this.addPackage(ev, index + 1)))}
                onRemove={this.state.data.package.length > 1 && ((ev) => this.removePackage(ev, index))}
                onChange={(ev) => (this.packageChange(ev, index))}
                packageOptionChange={(ev) => this.onPackageOptionChange(ev, index)}
                />
        ), this);

        
                    
        let credits = <CreditBoxWidget
                navigateTo={this.props.navigateTo}
                orderTotal={this.state.orderCarrierCost}>
            </CreditBoxWidget>;

        return <div className="page-order-creation">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersCreateSingle}>{credits}</PageTitle>
            <div className="page-content">

                <div className="single-order-container">
                    <div className="order-package-config">
                    <div className="package-subtitle">{this.le.packageConfigTitle}</div>
                        <div className="order-package-container">
                            {packages}
                        </div>
                    </div>

                    <div className="order-order-config">
                        <div className="order-subtitle">{this.le.configuration}</div>
                        <div className="flex-panel">
                            <UIInput name="orderNum" maxLength="100" onChange={this.orderChange} value={this.state.data.order.orderNum} label={this.le.orderNumLabel} mandatory={true} error={this.state.data.order.hasOwnProperty("orderNumError") ? this.state.data.order.orderNumError : false} />
                            <UISelect name="carrierId" onChange={this.orderChange} value={this.state.data.order.carrierId} label={this.le.courier} options={carrierSelectOptions} />
                            <UIInput name="orderContentValueStr" maxLength="10" onChange={this.orderChange} value={this.state.data.order.orderContentValueStr} label={this.le.orderContentValueLabel} mandatory={true} error={this.state.data.order.hasOwnProperty("orderContentValueError") ? this.state.data.order.orderContentValueError : false} />
                            <UIInput name="orderContentDesc" maxLength="10" onChange={this.orderChange} value={this.state.data.order.orderContentDesc} label={this.le.orderContentDescLabel} mandatory={true} error={this.state.data.order.hasOwnProperty("orderContentDescError") ? this.state.data.order.orderContentDescError : false} />
                        </div>
                        <UICheckbox name="orderContentDescCheck" onChange={this.orderChange} label={this.le.orderContentDescCheckLabel} value={this.state.data.order.orderContentDescCheck} error={this.state.data.order.hasOwnProperty("orderContentDescCheckError") ? this.state.data.order.orderContentDescCheckError : false} />
                    </div>

                    <div className="order-order-config">
                        <div className="order-subtitle">{this.le.services.title}</div>
                        <div className="grid-panel-3"> {
                            
                            Object.entries(this.state.data.services).map(([key, obj], idx) => {
                                return (
                                    <div key={key} className={`service-config ${key === 'triangulation' ? 'triangulation-service': ''}`}>
                                        <UICheckbox
                                            key={"chk-" + key} 
                                            name={key}
                                            value={obj.active} 
                                            label={this.le.services.service[idx].title}
                                            disabled={!obj.enabled}
                                            onChange={this.serviceChange} />

                                        {obj.type === 'text' && <UIInput
                                            key={"inp-" + key}
                                            maxLength={key == 'assicurazione' ? 10 : 10}
                                            name={key}
                                            value={obj.value}
                                            disabled={!(obj.enabled && obj.active)}
                                            onChange={this.serviceChange}
                                            error={obj.error || false} />}

                                        {(key === 'assicurazione' && obj.active)
                                            ? [
                                                <UICheckbox
                                                    key={uuidv4()}
                                                    name="acceptance"
                                                    label={this.le.acceptance}
                                                    value={this.state.data.checkbox.acceptance}
                                                    onChange={this.serviceChange}
                                                    error={this.state.data != null && this.state.data.hasOwnProperty("checkbox") && this.state.data.checkbox.hasOwnProperty("error") ? this.state.data.checkbox.error : false} />,
                                                <a key={uuidv4()} target="_blank" href={this.le.acceptanceLink.link}>{this.le.acceptanceLink.text}</a>
                                            ] : ''
                                        }
                                </div>
                                )
                            }, this)
                        }
                        </div>
                    </div>

                    {reactSections}

                    <UIButtonPad className="order-button-pad right" align="right">
                        <UIButton text={this.le.button} onClick={this.createOrder} className="slim confirm" />
                    </UIButtonPad>
                </div>
            </div>
            {modal}
        </div>;
    }
}